module.exports = __webpack_public_path__ + "img/Bear04.757c517e.png";